module.exports = __webpack_public_path__ + "img/files-categories.0556d5c7.svg";